export default __webpack_public_path__ + "static/media/topdev-validate.e51751bd.jpg";